'use strict';

var React = require('react');

var SvgSkeletonMajor = function SvgSkeletonMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 3,
    y: 3,
    fillOpacity: 0.12,
    rx: "0.25rem",
    ry: "0.25rem"
  }));
};
SvgSkeletonMajor.displayName = "SkeletonMajor";

exports.SvgSkeletonMajor = SvgSkeletonMajor;
